import { Mode } from "./AreaCursor.types";

export const DEFAULT_LABELS = {
  [Mode.CLICK]: "See more",
  [Mode.DRAG]: "Drag me",
};

export const FADE_OUT_DURATION = 0.5;
